/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { hideElementCss } from '../../../../../../utils/responsive';
import { SafePureComponent } from '../../../../../../utils/SafePureComponent';
import { MediaQueries } from '../../../../../../styles/Grid';
import { withConsumer } from '../../../../../../contexts';
import { RichFilteringConsumer } from '../../../../../../contexts/RichFilteringContext';
import * as styles from './index.styles';

export class SolutionOption extends SafePureComponent {
  buildQueryString = () => {
    const { value, richFilteringContext, closeModal } = this.props;
    const { replaceWindowUrl, storeUrlParams } = richFilteringContext.actions;
    const wsValue = value.replace(`/`, '');

    replaceWindowUrl({ ws: wsValue });
    storeUrlParams();
    closeModal();
  };

  renderIcon = () => {
    const { isCurrent } = this.props;

    if (!isCurrent) return null;

    return (
      <i
        css={[styles.checkmark, hideElementCss(MediaQueries.lgAndUp)]}
        className="icon-checkmark"
      />
    );
  };

  safeRender() {
    const { isCurrent, label } = this.props;
    const solutionOptionCss = [
      styles.defaultSolutionOption,
      isCurrent && styles.currentSolutionOption,
    ];

    return (
      <li css={styles.solutionItem}>
        <button css={solutionOptionCss} onClick={this.buildQueryString}>
          {this.renderIcon()}
          {label}
        </button>
      </li>
    );
  }
}

SolutionOption.displayName = 'SolutionOption';

SolutionOption.defaultProps = {
  isCurrent: false,
  label: '',
  value: '',
};

SolutionOption.propTypes = {
  isCurrent: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
};

export default withConsumer(
  RichFilteringConsumer,
  'richFilteringContext',
)(SolutionOption);
